import { getRoutePermission } from '@/constants/authorization/route-permissions'

const NavigationPermissionMixin = {
  methods: {
    checkSuperAdminRoute(item) {
      const isAdminRoute = this.$store.getters['navigation/isSuperAdminRoute']
      const isSuperAdmin = this.$store.getters['permissions/isSuperAdmin']

      return (!item.superAdmin && !isAdminRoute) || (item?.superAdmin && isAdminRoute && isSuperAdmin)
    },
    checkAdminPermission(item) {
      if (!item.adminPermissions || !item.adminPermissions?.length) return true
      const isSuperAdmin = this.$store.getters['permissions/isSuperAdmin']

      return isSuperAdmin && item.adminPermissions.some(permission => this.$store.getters['permissions/isSuperAdminHasPermission'](permission))
    },
    checkSubuserPermission(item) {
      const permissions = item.permission ?? item.permissions ?? getRoutePermission(item.route)
      if (!permissions || (Array.isArray(permissions) && !permissions.length)) return true

      const list = Array.isArray(permissions) ? permissions : [permissions]
      const requireAll = !!item.requireAllPermissions
      const checker = requireAll
        ? this.$store.getters['permissions/hasAllSubuserPermissions']
        : this.$store.getters['permissions/hasAnySubuserPermission']
      return checker(list)
    },
    hasVisibleNavChildren(item) {
      if (!item?.children?.length) return false
      return item.children.some(child => this.canView(child))
    },
    canView(item) {
      if (!item || (item.hide && typeof item.hide === 'function' && item.hide())) return false
      if (!this.checkSuperAdminRoute(item) || !this.checkAdminPermission(item)) {
        return false
      }

      if (item.children?.length) {
        return this.hasVisibleNavChildren(item)
      }

      return this.checkSubuserPermission(item)
    },
  },
}

export default NavigationPermissionMixin
